export enum enumPackageType {
  PALLET,
  SKID,
  CRATE,
  BOX,
  CARTON,
  CASE,
  PACKAGE,
  DRUM,
  BALE,
  BAG,
}
